import React, { useState, useEffect } from "react";
import Stepper from "react-stepper-horizontal";

import InfoPersonnelle from "./InfoPersonnelle";
import InfoCandidat from "./InfoCandidat";

// import QRCode from "qrcode";
// import { jsPDF } from "jspdf";
import Bunexe_service from "../../../Bunexe_service";

// import "./App.css";

import { toast } from "react-toastify";
import Mode_paiement from "./Mode_paiement";
import InfoTransaction from "./InfoTransaction";
import { useParams } from "react-router-dom";

import Ediplome from "./E_diplome";

const Intro = (props) => {
  // const [transactionId, setTransactionId]= useState("")
  let url_ = Bunexe_service.url;
  // const { location } = useParams();
  // let transactionId = location.search.transactionId;
  // console.log(location.search.transactionId);
  let v = props.location.search;
  let transactionId = "";
  if (v) {
    // let v = props.location.search;
    let firstIndex = v.indexOf("=");
    transactionId = v.substring(firstIndex + 1, v.length);
  }
  //console.log(props);
  //console.log(v);
  //console.log(location.search);

  const [etapes, setEtapes] = useState([
    { title: "Info Personnelle" },

    { title: "Choix documents" },
    { title: "Mode Paiement" },
    { title: "Id. Trx Mode Paiement" },

    { title: "Impression documents" },
  ]);
  const [valeurSelectionnee, setValeurSeclectionnee] =
    useState("releve_seulement");
  const [Info_personnelle, setInfo_Personnelle] = useState(null);
  const [matricule, setMatricule] = useState("");
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [telephone, setTelephone] = useState("");
  const [annee_participation, setAnneeParticipation] = useState("2026");
  const [methode_paiement, setMethode_paiement] = useState("");
  const [montant_a_payer, setMontantAPayer] = useState("150");
  const [orderId, setOrderId] = useState("");

  const [etapecourante, setEtapeCourante] = useState(0);

  const [date_trx, setDateTrx] = useState("");
  const [id_trx, setIdTrx] = useState("");

  const etapesuivante = () => {
    if (etapecourante < 4) setEtapeCourante(etapecourante + 1);
  };
  const etapeprecedente = () => {
    if (etapecourante > 0) setEtapeCourante(etapecourante - 1);
  };

  // const generateQR = async (
  //   type,
  //   identifiant,
  //   nom,
  //   prenom,
  //   annee,
  //   dnaiss,
  //   lieu,
  //   matricule,
  //   moy,
  //   section,
  //   session,
  //   Section_lib,
  //   sexe,
  //   notes
  // ) => {
  //   // let text = `${identifiant} , ${nom} ${prenom}, ${annee},${dnaiss},${lieu}, ${matricule}, ${moy}`;
  //   let text = `${identifiant}`;
  //   try {
  //     let u = await QRCode.toDataURL(text);
  //     //console.log(text);
  //     // console.log(await QRCode.toDataURL(text));
  //     setImageurl(u);
  //     // console.log(nom, prenom, annee, matricule, moy);
  //     if (type == "C") {
  //       printPdf(
  //         u,
  //         identifiant,
  //         nom,
  //         prenom,
  //         annee,
  //         dnaiss,
  //         lieu,
  //         matricule,
  //         moy,
  //         section,
  //         session,
  //         Section_lib
  //       );
  //     } else {
  //       printReleve(
  //         u,
  //         identifiant,
  //         nom,
  //         prenom,
  //         annee,
  //         dnaiss,
  //         lieu,
  //         matricule,
  //         moy,
  //         section,
  //         session,
  //         Section_lib,
  //         sexe,
  //         notes
  //       );
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const Rechercher = async () => {
    // let url_ = "http://localhost:8086/api";
    // let sc = window.screen.availWidth;
    // console.log("############   Screen Size    ###############");
    // console.log(sc);
    // console.log("############  Fin Screen Size    ###############");

    if (!annee_participation || !matricule || !nom || !prenom) {
      toast.error("Tous les champs sont obligatoires. Veuiller les remplir", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    // else if (annee_participation != "2022") {
    //   toast.error(
    //     "Le Service est disponible et gratuit seulement pour les candidats de Février 2022",
    //     {
    //       position: toast.POSITION.TOP_RIGHT,
    //     }
    //   );
    // }
    else {
      // an_section_matricule_nom/:annee/:codeMat/:nom/:prenom
      try {
        fetch(
          url_ +
            `/dossier/an_section_matricule_nom/${annee_participation}/${matricule}/${encodeURIComponent(
              nom,
            )}/${encodeURIComponent(prenom)}`,
        )
          .then((response) => response.json())
          .then((data) => {
            // console.log(data);
            // console.log(data.message);
            if (data.message) {
              toast.error(data.message, {
                position: toast.POSITION.TOP_RIGHT,
              });
            } else if (data.data && data.data?.length > 0) {
              console.log(data.data);
              data.data[0].dateNaiss = convertToDate(data.data[0].dateNaiss);
              setInfo_Personnelle(data.data[0]);
              etapesuivante();
            } else
              toast.error(
                "Information non - trouvée, Veuiller consulter le numéro d'ordre du candidat",
                {
                  position: toast.POSITION.TOP_RIGHT,
                },
              );
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log("Test");
        console.log(error);
      }
    }
  };

  const getTransactionById = () => {
    // e.preventDefault();

    // alert(JSON.stringify(Form_data));
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };

    try {
      fetch(
        url_ +
          `/dossier/moncash/getPaymentByTransactionId/?transactionId=${transactionId}`,
        requestOptions,
      )
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          if (data.hasError) {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            //afficherMessage(data.message);
          } else {
            setEtapeCourante(4);

            // handleShow();
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur d'insertion ...", error);
    }
    // alert(JSON.stringify(Form_data));
  };

  const convertToDate = (dat_) => {
    return dat_ != "N/A"
      ? dat_.substring(8, 10) +
          "/" +
          dat_.substring(5, 7) +
          "/" +
          dat_.substring(0, 4)
      : "N/A";
  };

  useEffect(() => {
    console.log("  POI ");
    if (transactionId) {
      console.log(` Le Numero de la transation est :${transactionId}`);
      let inf = JSON.parse(localStorage.getItem("info"));
      let m = JSON.parse(localStorage.getItem("montant"));
      let val_ = JSON.parse(localStorage.getItem("valeur"));
      setInfo_Personnelle(inf);
      setMontantAPayer(m);
      setValeurSeclectionnee(val_);
      // setEtapeCourante(4);
      // setEtapeCourante(4);
      getTransactionById();
    }
  }, []);

  return (
    <>
      {}
      <div>
        <h3 className="display-6 text-center mt-1 fst-italic mb-0">
          e-certificat
        </h3>
        {/* e-diplôme et/ou e-certificat */}
        <Stepper steps={etapes} activeStep={etapecourante} />
      </div>
      <div className="container">
        {/* justify-content-between */}
        <div className="row ">
          {etapecourante == 0 && (
            <div className=" col-xs-12 col-sm-12 col-md-6 offset-md-3 col-lg-6 offset-lg-3  mt-1">
              <div class="card">
                <div class="card-header">
                  <h6 className="display-6 text-center  fst-italic">
                    Information Personnelle
                  </h6>
                </div>
                <div class="card-body">
                  <InfoPersonnelle
                    matricule={matricule}
                    setMatricule={setMatricule}
                    nom={nom}
                    setNom={setNom}
                    prenom={prenom}
                    setPrenom={setPrenom}
                    telephone={telephone}
                    setTelephone={setTelephone}
                    annee_participation={annee_participation}
                    setAnneeParticipation={setAnneeParticipation}
                    Rechercher={Rechercher}
                  />
                </div>
              </div>
            </div>
          )}
          {etapecourante == 1 && (
            <div className="col-xs-12 col-sm-12 col-md-6 offset-md-3 col-lg-6 offset-lg-3  mt-2">
              <div class="card">
                <div class="card-header">
                  <h6 className="display-6 text-center  fst-italic">
                    Données sur le candidat
                  </h6>
                </div>
                <div class="card-body">
                  <InfoCandidat
                    Info_personnelle={Info_personnelle}
                    etapesuivante={etapesuivante}
                    setMontantAPayer={setMontantAPayer}
                    valeurSelectionnee={valeurSelectionnee}
                    setValeurSeclectionnee={setValeurSeclectionnee}
                    setOrderId={setOrderId}
                    orderId={orderId}
                  />
                </div>
              </div>
            </div>
          )}

          {etapecourante == 2 && (
            <div className="container">
              {/* className="col-xs-12 col-sm-12 col-md-6 offset-md-3 col-lg-6 offset-lg-3  mt-2" */}
              {/* <div class="card">
                <div class="card-header">
                  <h6 className="display-6 text-center  fst-italic">
                    Modalité de paiement
                  </h6>
                </div>
                <div class="card-body"> */}
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-4 offset-md-4 col-lg-4 offset-lg-4  mt-2">
                  <Mode_paiement
                    Info_personnelle={Info_personnelle}
                    etapesuivante={etapesuivante}
                    methode_paiement={methode_paiement}
                    setMethode_paiement={setMethode_paiement}
                    montant_a_payer={montant_a_payer}
                  />
                </div>
              </div>
            </div>
          )}
          {/* IdTransaction */}
          {etapecourante == 3 && (
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-4 offset-md-4 col-lg-4 offset-lg-4  mt-2">
                  <InfoTransaction
                    Info_personnelle={Info_personnelle}
                    etapesuivante={etapesuivante}
                    etapeprecedente={etapeprecedente}
                    methode_paiement={methode_paiement}
                    setMethode_paiement={setMethode_paiement}
                    montant_a_payer={montant_a_payer}
                    date_trx={date_trx}
                    setDateTrx={setDateTrx}
                    id_trx={id_trx}
                    setIdTrx={setIdTrx}
                    valeurSelectionnee={valeurSelectionnee}
                    setValeurSeclectionnee={setValeurSeclectionnee}
                    orderId={orderId}
                  />
                </div>
              </div>
            </div>
          )}
          {/* Impression e-documents */}
          {etapecourante == 4 && (
            <div className="container-fluid">
              <div className="row">
                {/* <div className="col-xs-12 col-sm-12 col-md-4 offset-md-4 col-lg-4 offset-lg-4  mt-2"> */}
                <Ediplome
                  Info_personnelle={Info_personnelle}
                  etapesuivante={etapesuivante}
                  etapeprecedente={etapeprecedente}
                  methode_paiement={methode_paiement}
                  setMethode_paiement={setMethode_paiement}
                  montant_a_payer={montant_a_payer}
                  date_trx={date_trx}
                  setDateTrx={setDateTrx}
                  id_trx={id_trx}
                  setIdTrx={setIdTrx}
                  valeurSelectionnee={valeurSelectionnee}
                  setValeurSeclectionnee={setValeurSeclectionnee}
                />
                {/* </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="container">
        <div className="mt-2 row justify-content-center">
          <div className="col-sm-3 col-sm-3 col-md-2 col-lg-1">
            <>
              <button
                type="button"
                onClick={etapeprecedente}
                class="btn btn-primary btn-sm"
              >
                {` <- `}
              </button>
              {`  `}
              <button
                type="button"
                onClick={(e) => {
                  setNom("");
                  setPrenom("");
                  setMatricule("");
                  setTelephone("");
                  setEtapeCourante(0);
                }}
                className="btn btn-primary btn-sm"
              >{` & `}</button>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;
